import React from 'react';
import { create } from 'jss';
import { ThemeProviderV4, StyledEngineProvider, StylesProviderV4, jssPreset, ThemeProvider } from '~/lib/bn-material-ui';
import { muiTheme, generateClassName } from '~/utility/BinSentry-ui-utility';

/**
 * For rendering react components in line with lit components
 *   - An insertionPoint prop is required to have styles placed in the correct location of the DOM
 *     this must be passed through from the parcels use in lit
 */
export function InLineStylesProvider(props) {
  const jss = create({
    ...jssPreset(),
    // Define a custom insertion point that JSS will look for when injecting the styles into the DOM.
    insertionPoint: props.insertionPoint,
  });

  return (
    <StyledEngineProvider jss={jss} generateClassName={generateClassName} injectFirst>
      <StylesProviderV4 jss={jss} generateClassName={generateClassName}>
        <ThemeProvider theme={muiTheme}>
          <ThemeProviderV4 theme={muiTheme}>
            {props.children}
          </ThemeProviderV4>
        </ThemeProvider>
      </StylesProviderV4>
    </StyledEngineProvider>
  );
}

/**
 * For rendering react dialog components
 */
export function DialogStylesProvider(props) {
  const jss = create({
    ...jssPreset(),
    // Define a custom insertion point that JSS will look for when injecting the styles into the DOM.
    insertionPoint: props.insertionPoint,
  });

  return (
    <StyledEngineProvider jss={jss} generateClassName={generateClassName} injectFirst>
      <StylesProviderV4 jss={jss} generateClassName={generateClassName}>
        <ThemeProvider theme={muiTheme}>
          <ThemeProviderV4 theme={muiTheme}>
            {props.children}
          </ThemeProviderV4>
        </ThemeProvider>
      </StylesProviderV4>
    </StyledEngineProvider>
  );
}
